import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { IoEllipsisHorizontal } from "react-icons/io5";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import ReactDOMServer from "react-dom/server";

const SlotContent = ({ className, week, periodCodes }) => (
  <>
    {week.data.map((ptoRequest) => {
      const period = periodCodes?.find(
        (pd) => pd._id === ptoRequest?.pto?.period
      );
      return (
        <div className={className} key={ptoRequest.id}>
          <span>{ptoRequest.employee}</span>
          <span>
            {ptoRequest.pto.duration === 1
              ? "PTO"
              : `${period?.label || "1/2"} PTO`}
          </span>
        </div>
      );
    })}
  </>
);

SlotContent.propTypes = {
  className: PropTypes.string,
  week: PropTypes.object,
  periodCodes: PropTypes.array
};

SlotContent.defaultProps = {
  className: "",
  week: {},
  periodCodes: []
};

const CalendarSlot = ({ week, isWeekend, periodCodes }) => {
  const containerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflow = () => {
    const el = containerRef.current;
    if (el) {
      setIsOverflowing(
        el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth
      );
    }
  };

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new ResizeObserver(() => {
      checkOverflow();
    });

    observer.observe(el);

    return () => {
      observer.unobserve(el);
    };
  }, [week]);

  const shouldShowTooltip = week.data.length > 6 || isOverflowing;

  return (
    <div className={`calendar-slot-container ${isWeekend && "is-weekend"}`}>
      {week.showWeekday && <h2>{week.weekday}</h2>}
      <div className="calendar-slot-wrapper content-wrapper">
        <span className="day">{week.day}</span>
        <div className="pto-data-container" ref={containerRef}>
          <SlotContent
            className="pto-data-wrapper"
            periodCodes={periodCodes}
            week={week}
          />
        </div>
        <div className="see-more-container">
          {shouldShowTooltip && (
            <OverlayTrigger
              key="left"
              placement="left"
              overlay={
                <Tooltip id="tooltip-left">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ReactDOMServer.renderToString(
                        <SlotContent week={week} />
                      )
                    }}
                  />
                </Tooltip>
              }
            >
              <IoEllipsisHorizontal />
            </OverlayTrigger>
          )}
        </div>
      </div>
    </div>
  );
};

CalendarSlot.propTypes = {
  week: PropTypes.object,
  isWeekend: PropTypes.bool,
  periodCodes: PropTypes.array
};

CalendarSlot.defaultProps = {
  week: {},
  isWeekend: false,
  periodCodes: []
};

export default CalendarSlot;
